import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ToastContainerDirective } from 'ngx-toastr';
import { UserService } from '../../../services/user.service';
import { AtlasToastService } from '../../../services/atlas-toast.service';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { checkPassword } from '@utils/validators';

function matchingPasswords(matchTo: string): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    return !!control.parent && !!control.parent.value && control.value === control.parent.get(matchTo).value
      ? null
      : { notEquivalent: true };
  };
}

@Component({
  selector: 'wsb-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: false
})
export class ChangePasswordComponent implements OnInit, AfterViewInit {
  @ViewChild(ToastContainerDirective) modalToastContainer: ToastContainerDirective;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;
  @Input() public typeResetPassword: 'web' | 'api';
  passwordForm: UntypedFormGroup;
  faPasswordOldIconShow = faEye;
  showPasswordOld = false;
  faPasswordNewIconShow = faEye;
  showPasswordNew = false;
  faPasswordRepeatIconShow = faEye;
  showPasswordRepeat = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private atlasToast: AtlasToastService
  ) {}

  ngOnInit() {
    this.passwordForm = this.formBuilder.group({
      currentPassword: this.formBuilder.control('', []),
      newPassword: this.formBuilder.control('', [Validators.required, checkPassword()]),
      confirmNewPassword: this.formBuilder.control('', [Validators.required, matchingPasswords('newPassword')])
    });

    if (this.typeResetPassword === 'web') {
      this.passwordForm.get('currentPassword').setValidators([Validators.required]);
      this.passwordForm.get('currentPassword').updateValueAndValidity();
    }
  }

  doSubmit() {
    this.passwordForm.disable();
    switch (this.typeResetPassword) {
      case 'web':
        this.callUpdatePasswordWEB();
        break;
      case 'api':
        this.callUpdatePasswordAPI();
        break;
    }
  }

  private callUpdatePasswordWEB() {
    this.userService
      .updatePassword({
        currentPassword: this.passwordForm.controls.currentPassword.value,
        newPassword: this.passwordForm.controls.newPassword.value,
        newPasswordControl: this.passwordForm.controls.confirmNewPassword.value
      })
      .subscribe(
        updatedUser => this.activeModal.close(updatedUser),
        error => {
          this.passwordForm.enable();
          this.atlasToast.error('common_error', null, null, this.modalToastContainer);
        },
        () => {
          this.atlasToast.success('reset_ok', null);
        }
      );
  }

  private callUpdatePasswordAPI() {
    this.userService
      .updatePasswordAPI({
        newPassword: this.passwordForm.controls.newPassword.value
      })
      .subscribe(
        updatedUser => this.activeModal.close(updatedUser),
        error => {
          this.passwordForm.enable();
          this.atlasToast.error('common_error', null, null, this.modalToastContainer);
        },
        () => {
          this.atlasToast.success('reset_ok', null);
        }
      );
  }

  showHidePassWordOld() {
    this.showPasswordOld = !this.showPasswordOld;
    if (this.showPasswordOld) {
      this.faPasswordOldIconShow = faEyeSlash;
    } else {
      this.faPasswordOldIconShow = faEye;
    }
  }

  showHidePassWordNew() {
    this.showPasswordNew = !this.showPasswordNew;
    if (this.showPasswordNew) {
      this.faPasswordNewIconShow = faEyeSlash;
    } else {
      this.faPasswordNewIconShow = faEye;
    }
  }

  showHidePassWordRepeat() {
    this.showPasswordRepeat = !this.showPasswordRepeat;
    if (this.showPasswordRepeat) {
      this.faPasswordRepeatIconShow = faEyeSlash;
    } else {
      this.faPasswordRepeatIconShow = faEye;
    }
  }

  cancel() {
    this.activeModal.dismiss();
  }
  ngAfterViewInit(): void {
    let labelInfo = '';
    switch (this.typeResetPassword) {
      case 'web':
        labelInfo = 'change_password_alert';
        break;
      case 'api':
        labelInfo = 'change_apipassword_alert';
        break;
    }
    this.atlasToast.info(labelInfo, '', -1, this.toastContainer);
  }
}
